import React from 'react';
import PropTypes from 'prop-types';
import rightArrow from '../../../assets/img/rightarrow.svg';

const steps = [
  { id: 1, title: 'COMPANY DETAILS', number: '1' },
  { id: 2, title: 'USER DETAILS', number: '2' },
  { id: 3, title: 'SUBSCRIPTION DETAILS', number: '3' },
];

function StepIndicator({ step, currentStep, isLast }) {
  const isActive = currentStep === step.id;
  const isCompleted = currentStep > step.id;

  const getStepClassName = () => {
    if (isCompleted) return 'step-container completed';
    if (isActive) return 'step-container active';
    return 'step-container inactive';
  };

  return (
    <>
      <div className={getStepClassName()}>
        <div className="step-circle">
          <span className="step-number">{step.number}</span>
        </div>
        <span className="step-label">{step.title}</span>
      </div>
      {!isLast && (
        <div className="step-arrow">
          <img src={rightArrow} alt="arrow" />
        </div>
      )}
    </>
  );
}

function Progress({ step }) {
  const currentStepData = steps.find((stepData) => stepData.id === step);

  return (
    <div className="progress-container">
      <div className="step-indicators">
        <div className="mobile-current-step">
          {currentStepData && (
            <StepIndicator
              key={currentStepData.id}
              step={currentStepData}
              currentStep={step}
              isLast={true}
            />
          )}
        </div>
        <div className="desktop-all-steps">
          {steps.map((stepData, index) => (
            <StepIndicator
              key={stepData.id}
              step={stepData}
              currentStep={step}
              isLast={index === steps.length - 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

StepIndicator.propTypes = {
  step: PropTypes.object.isRequired,
  currentStep: PropTypes.number.isRequired,
  isLast: PropTypes.bool.isRequired,
};

Progress.propTypes = {
  step: PropTypes.number.isRequired,
};

export default Progress;
